import { ReactElement, ReactNode, useCallback, useMemo } from 'react';
import { TextField, MenuItem, ListItemText, Box } from '@mui/material';

import { LogisticZoneType } from '~globals/types/enums';
import { LOGISTICS_ZONES_OPTIONS } from '~constants/logisiticZones';
import { getLabelTextForTypeLogisticZone } from '~utils/logisiticsZones';

import { SelectZoneLogisticTypeProps } from './types';

const SelectZoneLogisticType = (
  props: SelectZoneLogisticTypeProps,
): ReactElement => {
  const renderValue = useCallback((selectedValue: unknown): ReactNode => {
    const currentValue = getLabelTextForTypeLogisticZone(
      selectedValue as LogisticZoneType,
      'normal',
    );

    return currentValue ?? '';
  }, []);

  const nameField = useMemo(
    () => props.name ?? props.id,
    [props.name, props.id],
  );

  return (
    <TextField
      {...props}
      select
      SelectProps={{
        renderValue,
        MenuProps: {
          PaperProps: {
            style: {
              width: 'min-content',
            },
          },
        },
        displayEmpty: true,
      }}
    >
      <MenuItem value="" sx={{ display: 'none' }}>
        Empty
      </MenuItem>

      {LOGISTICS_ZONES_OPTIONS.map((option) => (
        <MenuItem
          key={`${nameField}-${option.value}`}
          value={option.value}
          sx={{ whiteSpace: 'pre-wrap' }}
        >
          <Box
            component="img"
            {...option.icon}
            sx={{ height: 55, width: 55, marginRight: 2 }}
          />

          <ListItemText
            primary={option.label}
            primaryTypographyProps={{
              variant: 'body1',
              color: 'primary.main',
              fontWeight: 500,
            }}
            secondary={option.description}
            secondaryTypographyProps={{ variant: 'caption' }}
          />
        </MenuItem>
      ))}
    </TextField>
  );
};

export default SelectZoneLogisticType;
